import BangloreSection from "./home/BangloreSection";
import RentingComparesion from "./RentingComparesion";
import PopularDep from "./PopularDep";
import CityTour from "./CityTour";
import FeaturedTrips from "./home/FeaturedTrips";
import WhyChoose from "./home/WhyChoose";
import CityTourHighlight from "./home/CityTourHighlight";
import Testimonials from "./home/Testimonials";

function HomePage() {
    return (
        <div>
            <BangloreSection />
            {/* <JoinTeam/> */}
            {/* <CityTour /> */}

            <FeaturedTrips />
            <PopularDep />
            <Testimonials />
            <WhyChoose />
        </div>
    );
}

export default HomePage;
